module.exports = ".com-profesional-modal__modal-dialog {\n  max-width: 600px;\n}\n.com-profesional-modal__modal-header {\n  border-bottom: 0;\n}"